module.exports = __webpack_public_path__ + "static/img/topIcon.f7bfe95.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/y2wm/topIcon.png
// module id = 7L11
// module chunks = 1